/**
 * Created by WebStorm.
 * User: athukorala
 * Date: 7/10/19
 * Time: 10:46 AM
 */
import React from 'react';
import {connect} from 'react-redux'
import * as actionCreators from '../../store/Action'
import Image_uploader from '../../assets/img/img_upload/upload.svg'
import {Col, Row} from "reactstrap";
import {Button as SementicBtn} from "semantic-ui-react";

class ImageUpload extends React.Component {
  onFileChange = async (e) => {
    const imageDataUrl = await readFile(e);
    this.props.setScreenshot(imageDataUrl)
  };

  constructor(props) {
    super(props);
    this.state = {
      file: '',
      imagePreviewUrl: '',
      liveImage: ''
    };
  }

  _handleSubmit(e) {
    e.preventDefault();
  }

  _handleImageChange(e) {
    const urlArray = [];
    e.preventDefault();

    let reader = new FileReader();
    let file = e.target.files[0];
    this.onFileChange(file);

  }

  render() {
    return (
      <div className="previewComponent select-image-reg-form">
        <form onSubmit={(e) => this._handleSubmit(e)}>
          <input className="fileInput"
                 id="image-upload-visitortags"
                 type="file"
                 accept="image/png, image/jpeg"
                 style={{
                   display: 'none',
                   cursor: 'pointer',
                   zIndex: '1',
                   position: 'absolute',
                   marginTop: '0%',
                   opacity: '0',
                   width: '200px',
                   height: '200px',
                 }}

                 onChange={(e) => this._handleImageChange(e)}/>
        </form>
        <label style={{
          background: "#8a8a8a",
          color: "white",
          width: '250px',
          borderRadius: ".28571429rem",
          cursor: 'pointer',
          verticalAlign: "baseline",
          lineHeight: "1em",
          textAlign: "center",
          textDecoration: "none",
          boxShadow: "0 0 0 1px transparent inset, 0 0 0 0 rgba(34,36,38,.15) inset;",
          display: "grid",
          alignItems: "center",
          margin:"auto"


        }} htmlFor={"image-upload-visitortags"} className="px-5__ ">Choose Gallery
        </label>
      </div>
    )
  }
}

function readFile(file) {
  return new Promise(resolve => {
    const reader = new FileReader();
    reader.addEventListener("load", () => resolve(reader.result), false);
    reader.readAsDataURL(file);
  });
}


const mapDispatchToProps = (dispatch) => {
  return {
    imageUploaderHandler: (image) => dispatch(actionCreators.imageUploaderHandler(image))
  }
};

export default connect(null, mapDispatchToProps)(ImageUpload);
